<div class="setting">
  <ul class="nav nav-tabs line-tab fixnav">
    <li *ngIf="userPermissions?.roles_setting?.view" class="nav-item" role="presentation">
      <a class="nav-link active" data-toggle="tab" href="#roles" role="tab" aria-selected="true">Roles</a>
    </li>
    <li *ngIf="userPermissions?.system_users_setting?.view" class="nav-item" role="presentation">
      <a class="nav-link" data-toggle="tab" href="#system_users" role="tab" aria-selected="false">System Users</a>
    </li>
    <li *ngIf="userPermissions?.union_locals_setting?.view" class="nav-item" role="presentation">
      <a class="nav-link" data-toggle="tab" href="#union_locals" role="tab" aria-selected="false"> Union Locals</a>
    </li>
    <li *ngIf="userPermissions?.design_setting?.view" class="nav-item" role="presentation">
      <a
        class="nav-link"
        data-toggle="tab"
        href="#design"
        role="tab"
        aria-selected="false"
        onclick="triggerColorPickerClick()"
        >Design</a
      >
    </li>
    <li *ngIf="userPermissions?.smtp_setting?.view" class="nav-item" role="presentation">
      <a class="nav-link" data-toggle="tab" href="#smtp" role="tab" aria-selected="false">SMTP</a>
    </li>
  </ul>

  <div class="tab-content mainTabContent">
    <!-- Roles -->
    <div *ngIf="userPermissions?.roles_setting?.view" class="tab-pane fade show active" id="roles" role="tabpanel">
      <app-roles [roles_setting]="userPermissions.roles_setting"></app-roles>
    </div>

    <!-- System Users -->
    <div *ngIf="userPermissions?.system_users_setting?.view" class="tab-pane fade" id="system_users" role="tabpanel">
      <app-users [system_users_setting]="userPermissions.system_users_setting"></app-users>
    </div>

    <!-- Union Locals -->
    <div *ngIf="userPermissions?.union_locals_setting?.view" class="tab-pane fade" id="union_locals" role="tabpanel">
      <app-union-locals [union_locals_setting]="userPermissions.union_locals_setting"></app-union-locals>
    </div>

    <!-- SMTP -->
    <div *ngIf="userPermissions?.smtp_setting?.view" class="tab-pane fade" id="smtp" role="tabpanel">
      <app-smtp-configuration [smtp_setting]="userPermissions.smtp_setting"> </app-smtp-configuration>
    </div>
  </div>
</div>
